import {IStore} from "modules/types/store";
import {IOddEntity, IOddWithPlayer} from "modules/types/odds";
import {getPlayers} from "modules/selectors/players";
import {keyBy} from "lodash";
import {createSelector} from "reselect";

export interface IOddEntityWithPlayer extends Omit<IOddEntity, "odds"> {
	odds: IOddWithPlayer[];
}

export const getOddsState = ({odds}: IStore) => odds;

export const getOddsByEventID = createSelector(
	getOddsState,
	(odds) => (eventID?: number | null) => eventID != null ? odds.byEventID[eventID] : undefined
);

export const getOddsWithPlayerByEventID = createSelector(
	getOddsState,
	getPlayers,
	(odds, players) =>
		(eventID?: number | null): IOddEntityWithPlayer | undefined => {
			if (eventID == null) return undefined;

			const entity = odds.byEventID[eventID];
			if (!entity) return undefined;

			const playersByID = keyBy(players, "id");

			return {
				...entity,
				odds: entity.odds.map((odd) => ({
					...odd,
					player: playersByID[odd.player_id] || null,
				})),
			};
		}
);

export const getIsOddsLoading = createSelector(getOddsState, (odds) => odds.isLoading);
